import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { Persona } from '../BeFi20.meta';

export const BEFI20_DISABLE_ERROR_REGEX = /is not enabled/i;
export const BEFI20_NOT_COMPLETED_ERROR_REGEX = /not yet completed/i;

export type SimilarityDTO = 'Low' | 'Varied' | 'High';

export interface PersonaDTO {
  initials: string;
  title: string;
  description: string;
  category: Persona;
  score: number;
}

export interface AlignmentDTO {
  initials: string;
  name: string;
  score: number;
  id: string;
  similarity: SimilarityDTO;
}

export interface PendingItemDTO {
  initials: string;
  name: string;
  id: string;
  dateInvited: string;
}

export interface OverviewDTO {
  persona: PersonaDTO;
  surveyId: string;
  alignments: AlignmentDTO[];
  pendingInvites: PendingItemDTO[];
  pendingRequests: PendingItemDTO[];
}

const fetchOverview = async (clientId: number): Promise<OverviewDTO> => {
  const [data] = await Promise.all([
    authFetch(urlWithParams('/BeFi20/overview', { clientId })),
    new Promise(r => setTimeout(r, 1000)),
  ]);

  return data;
};

export const useOverviewQuery = () => {
  const clientId = useClientId();

  return useQuery(queryKeys.overview(clientId), () => fetchOverview(clientId), {
    cacheTime: 0,

    retry(failureCount, error) {
      // Do not retry when BeFi20 is disabled or workflow is not yet completed
      return !(
        BEFI20_DISABLE_ERROR_REGEX.test(error.message) ||
        BEFI20_NOT_COMPLETED_ERROR_REGEX.test(error.message) ||
        failureCount > 2
      );
    },

    refetchInterval: 60_000,
  });
};
